import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { JsonFormStructure } from 'src/app/core/models/vs-models/json-form.model';
import { CommonApiErrorsHandler } from 'src/app/core/services/common-api-errors-handler.service';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiHandlingService {

  public formData!: JsonFormStructure;
  headers = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  constructor(private http: HttpClient, private commonApiErrorsHandler: CommonApiErrorsHandler) { }

  concatQueryParams(queryParams: any) {
    let params = new HttpParams();
    for (const key in queryParams) {
      if (queryParams.hasOwnProperty(key)) {
        params = params.set(key, queryParams[key]);
      }
    }
    return params;
  }

  getReq(reqType: number=1, url: string, data={}): any {
    let request_response: any;
    switch(reqType) {
      case 1: request_response = this.http.get(url).pipe(catchError(this.commonApiErrorsHandler.handleError));
      break;
      case 2: request_response = this.http.post(url, data).pipe(catchError(this.commonApiErrorsHandler.handleError));
      break;
      case 3: request_response = this.http.put(url, data).pipe(catchError(this.commonApiErrorsHandler.handleError));
      break;
      // NOTE: FOR GET REQUEST HAVING QUERY PARAMS USE CASE 4
      case 4: request_response = this.http.get(url, {'params': this.concatQueryParams(data)}).pipe(catchError(this.commonApiErrorsHandler.handleError));
      break;
      case 5: request_response = this.http.patch(url, data).pipe(catchError(this.commonApiErrorsHandler.handleError));
      break;
      case 6: request_response = this.http.post(url, data,{ responseType: 'blob' }).pipe(catchError(this.commonApiErrorsHandler.handleError));
      break;
      case 7: request_response = this.http.request('delete', url, { body: data }).pipe(catchError(this.commonApiErrorsHandler.handleError));
      break;
      case 8: request_response = this.http.get(url, { headers: data }).pipe(catchError(this.commonApiErrorsHandler.handleError));
      break;
      case 9: request_response = this.http.get(url, { params: this.concatQueryParams(data), responseType: 'blob' }).pipe(catchError(this.commonApiErrorsHandler.handleError));
      break;
      default: request_response = this.http.get(url).pipe(catchError(this.commonApiErrorsHandler.handleError));
      break;
    }
    return request_response;
  }



      /*
    1. Create a switch statement
    2. Create all the usefull APIs when needed

    Method getReq Parameters should have:
    1. request type(default = get),
    2. domain=external/internal(default= environment), subdomain=,
    3. body
    4. parameter

    Method getReq body should have:
    1.

    */

}
